import axios from 'utils/axios';
import { YONETICI, BINA_SAKINI } from 'utils/roles';

// ==============================|| API - RAPORLAMALAR (MODÜL 10) ||============================== //
// Rapor endpoint'leri SWR ile DEĞİL, imperatif axios çağrılarıyla kullanılır
// ("Raporu Getir" butonuna tıklanınca sunucuya gidilir) — bkz. RaporSayfasi.jsx.

const HER_IKI_ROL = [YONETICI, BINA_SAKINI];
const SADECE_YONETICI = [YONETICI];

const FINANSAL_OZET = 'raporlar/finansal-ozet/';
const ALACAK_TAHSILAT = 'raporlar/alacak-tahsilat/';
const BORC_ODEME = 'raporlar/borc-odeme/';
const DAIRE_KISI_CARI = 'raporlar/daire-kisi-cari/';
const MUHASEBE_YONETIM = 'raporlar/muhasebe-yonetim/';

// Her rapor: backend RAPOR_KATALOGU (bkz. reports/base.py alt sınıfları) ile
// kod/url_path birebir eşleşir. `route`: SPA menü/route path'i. `donemFiltresi`:
// baslangıç/bitiş tarihi filtresi gösterilsin mi. `ekFiltreler`: kategoriye özel
// query param'lar (backend'de `request.query_params.get(...)` ile okunanlarla
// birebir aynı isimde olmalı — bkz. reports/views_*.py). `secici`: 'daire'|'kisi'
// ise özel bir seçim alanı gerekir (D1/D2). `pdfSadece`: yalnızca PDF (F1).
export const RAPOR_KATALOGU = [
  // A — Finansal Özet Raporları
  {
    kod: 'a1_hesap_ozeti',
    ad: 'Hesap Özeti',
    route: '/raporlar/a1-hesap-ozeti',
    kategoriPrefix: FINANSAL_OZET,
    urlPath: 'hesap-ozeti',
    roller: HER_IKI_ROL,
    donemFiltresi: true,
    ekFiltreler: []
  },
  {
    kod: 'a2_gelir_gider_raporu',
    ad: 'Gelir-Gider Raporu',
    route: '/raporlar/a2-gelir-gider-raporu',
    kategoriPrefix: FINANSAL_OZET,
    urlPath: 'gelir-gider-raporu',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: []
  },
  {
    kod: 'a3_kasa_hareketleri_raporu',
    ad: 'Kasa Hareketleri Raporu',
    route: '/raporlar/a3-kasa-hareketleri-raporu',
    kategoriPrefix: FINANSAL_OZET,
    urlPath: 'kasa-hareketleri-raporu',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: [{ ad: 'kasa', etiket: 'Kasa ID(leri) (virgülle, boş=tümü)', tip: 'metin' }]
  },
  {
    kod: 'a4_net_durum_raporu',
    ad: 'Net Durum Raporu',
    route: '/raporlar/a4-net-durum-raporu',
    kategoriPrefix: FINANSAL_OZET,
    urlPath: 'net-durum-raporu',
    roller: SADECE_YONETICI,
    donemFiltresi: false,
    ekFiltreler: []
  },
  // B — Alacak / Tahsilat Raporları
  {
    kod: 'b1_detayli_alacak_listesi',
    ad: 'Detaylı Alacak Listesi',
    route: '/raporlar/b1-detayli-alacak-listesi',
    kategoriPrefix: ALACAK_TAHSILAT,
    urlPath: 'detayli-alacak-listesi',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: [{ ad: 'tur', etiket: 'Tür (aidat/ek_odenek/manuel, boş=tümü)', tip: 'metin' }]
  },
  {
    kod: 'b2_borclu_listesi',
    ad: 'Borçlu Listesi (Gecikmiş Alacaklar)',
    route: '/raporlar/b2-borclu-listesi',
    kategoriPrefix: ALACAK_TAHSILAT,
    urlPath: 'borclu-listesi',
    roller: SADECE_YONETICI,
    donemFiltresi: false,
    ekFiltreler: [{ ad: 'min_gun', etiket: 'Gecikme (gün) — en az', tip: 'sayi' }]
  },
  {
    kod: 'b3_gecikme_faizi_raporu',
    ad: 'Gecikme Faizi Raporu',
    route: '/raporlar/b3-gecikme-faizi-raporu',
    kategoriPrefix: ALACAK_TAHSILAT,
    urlPath: 'gecikme-faizi-raporu',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: []
  },
  {
    kod: 'b4_tahsilat_raporu',
    ad: 'Tahsilat Raporu',
    route: '/raporlar/b4-tahsilat-raporu',
    kategoriPrefix: ALACAK_TAHSILAT,
    urlPath: 'tahsilat-raporu',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: []
  },
  {
    kod: 'b5_donemsel_alacaklar_raporu',
    ad: 'Dönemsel Alacaklar Raporu',
    route: '/raporlar/b5-donemsel-alacaklar-raporu',
    kategoriPrefix: ALACAK_TAHSILAT,
    urlPath: 'donemsel-alacaklar-raporu',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: [{ ad: 'donem', etiket: 'Dönem (YYYY-AA, opsiyonel)', tip: 'metin' }]
  },
  // C — Borç / Ödeme Raporları
  {
    kod: 'c1_detayli_borc_listesi',
    ad: 'Detaylı Borç Listesi',
    route: '/raporlar/c1-detayli-borc-listesi',
    kategoriPrefix: BORC_ODEME,
    urlPath: 'detayli-borc-listesi',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: [{ ad: 'durum', etiket: 'Durum (acik/kismi_odendi/kapandi, boş=tümü)', tip: 'metin' }]
  },
  {
    kod: 'c2_vadesi_gecen_borclar',
    ad: 'Vadesi Geçen Borçlar',
    route: '/raporlar/c2-vadesi-gecen-borclar',
    kategoriPrefix: BORC_ODEME,
    urlPath: 'vadesi-gecen-borclar',
    roller: SADECE_YONETICI,
    donemFiltresi: false,
    ekFiltreler: []
  },
  {
    kod: 'c3_cari_borc_durumu',
    ad: 'Cari Borç Durumu (Firma Bazlı)',
    route: '/raporlar/c3-cari-borc-durumu',
    kategoriPrefix: BORC_ODEME,
    urlPath: 'cari-borc-durumu',
    roller: SADECE_YONETICI,
    donemFiltresi: false,
    ekFiltreler: []
  },
  {
    kod: 'c4_odeme_raporu',
    ad: 'Ödeme Raporu',
    route: '/raporlar/c4-odeme-raporu',
    kategoriPrefix: BORC_ODEME,
    urlPath: 'odeme-raporu',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: []
  },
  // D — Daire / Kişi / Cari Raporları
  {
    kod: 'd1_daire_finansal_durumu',
    ad: 'Daire Finansal Durumu',
    route: '/raporlar/d1-daire-finansal-durumu',
    kategoriPrefix: DAIRE_KISI_CARI,
    urlPath: 'daire-finansal-durumu',
    roller: HER_IKI_ROL,
    donemFiltresi: false,
    ekFiltreler: [],
    secici: 'daire'
  },
  {
    kod: 'd2_kisi_finansal_durumu',
    ad: 'Kişi Finansal Durumu',
    route: '/raporlar/d2-kisi-finansal-durumu',
    kategoriPrefix: DAIRE_KISI_CARI,
    urlPath: 'kisi-finansal-durumu',
    roller: SADECE_YONETICI,
    donemFiltresi: false,
    ekFiltreler: [],
    secici: 'kisi'
  },
  {
    kod: 'd3_daire_listesi',
    ad: 'Daire Listesi',
    route: '/raporlar/d3-daire-listesi',
    kategoriPrefix: DAIRE_KISI_CARI,
    urlPath: 'daire-listesi',
    roller: SADECE_YONETICI,
    donemFiltresi: false,
    ekFiltreler: []
  },
  {
    kod: 'd4_kisi_listesi',
    ad: 'Kişi Listesi',
    route: '/raporlar/d4-kisi-listesi',
    kategoriPrefix: DAIRE_KISI_CARI,
    urlPath: 'kisi-listesi',
    roller: SADECE_YONETICI,
    donemFiltresi: false,
    ekFiltreler: []
  },
  {
    kod: 'd5_plaka_listesi',
    ad: 'Plaka Listesi',
    route: '/raporlar/d5-plaka-listesi',
    kategoriPrefix: DAIRE_KISI_CARI,
    urlPath: 'plaka-listesi',
    roller: SADECE_YONETICI,
    donemFiltresi: false,
    ekFiltreler: []
  },
  {
    kod: 'd6_cari_firma_listesi',
    ad: 'Cari Firma Listesi',
    route: '/raporlar/d6-cari-firma-listesi',
    kategoriPrefix: DAIRE_KISI_CARI,
    urlPath: 'cari-firma-listesi',
    roller: SADECE_YONETICI,
    donemFiltresi: false,
    ekFiltreler: []
  },
  // E — Muhasebe Raporları
  {
    kod: 'e1_defteri_kebir',
    ad: 'Defteri Kebir',
    route: '/raporlar/e1-defteri-kebir',
    kategoriPrefix: MUHASEBE_YONETIM,
    urlPath: 'defteri-kebir',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: [{ ad: 'kasa', etiket: 'Kasa ID (boş=tümü)', tip: 'sayi' }]
  },
  {
    kod: 'e2_gelir_bakiyeleri',
    ad: 'Gelir Bakiyeleri',
    route: '/raporlar/e2-gelir-bakiyeleri',
    kategoriPrefix: MUHASEBE_YONETIM,
    urlPath: 'gelir-bakiyeleri',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: []
  },
  // F — Denetim / Yönetim Raporları
  {
    kod: 'f1_denetleme_raporu',
    ad: 'Denetleme Raporu',
    route: '/raporlar/f1-denetleme-raporu',
    kategoriPrefix: MUHASEBE_YONETIM,
    urlPath: 'denetleme-raporu',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: [],
    pdfSadece: true
  },
  {
    kod: 'f2_yonetim_ozet_raporu',
    ad: 'Yönetim Özet Raporu',
    route: '/raporlar/f2-yonetim-ozet-raporu',
    kategoriPrefix: MUHASEBE_YONETIM,
    urlPath: 'yonetim-ozet-raporu',
    roller: SADECE_YONETICI,
    donemFiltresi: true,
    ekFiltreler: []
  },
  // G — Planlama Raporları
  {
    kod: 'g1_isletme_projesi',
    ad: 'İşletme Projesi (Bütçe vs. Gerçekleşen)',
    route: '/raporlar/g1-isletme-projesi',
    kategoriPrefix: MUHASEBE_YONETIM,
    urlPath: 'isletme-projesi',
    roller: SADECE_YONETICI,
    donemFiltresi: false,
    ekFiltreler: [{ ad: 'butce_plan', etiket: 'Bütçe Planı ID (boş=aktif plan)', tip: 'sayi' }]
  }
];

export function raporGetir(kategoriPrefix, urlPath, params) {
  return axios.get(`${kategoriPrefix}${urlPath}/`, { params }).then((res) => res.data);
}

// PDF/Excel indirme: JWT header'ı ancak axios isteğiyle taşınır (window.open/
// düz <a href> doğrudan API URL'sine gidip 401 alır) — bkz. api/finans.js
// sayacSablonIndir aynı desen. Dosya adı backend'in Content-Disposition
// header'ından okunur (reports/utils.py her zaman ayarlıyor).
export async function raporIndir(kategoriPrefix, urlPath, params, format) {
  const response = await axios.get(`${kategoriPrefix}${urlPath}/`, {
    params: { ...params, export: format },
    responseType: 'blob'
  });
  const disposition = response.headers['content-disposition'] || '';
  const eslesme = disposition.match(/filename="?([^"]+)"?/);
  const dosyaAdi = eslesme ? eslesme[1] : `rapor.${format === 'excel' ? 'xlsx' : 'pdf'}`;

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = dosyaAdi;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
